import sourcing from "./sourcing"

export default {
    zh:{
        sourcing:{
            ...sourcing.zh
        }
    },
    en:{
        sourcing:{
            ...sourcing.en
        }
    }
}